import { useStickyState } from './useStickyState';

export function useLang() {
  const [lang, setLang] = useStickyState('en', 'lang');

  return { lang, setLang, isKorean: lang === 'ko' };
}
